import OptionalImage from '@src/components/optional-image';
import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';
import OrderSuccessModalStore from './store';

const styles = require('./index.less');

/**
 * 预约前置弹窗
 */
const OrderSuccessModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={cx(styles.orderSuccessModalRoot)}>
        <Link className={styles.closeBtn} onClick={store.onClickClose} />
        <div className={styles.title} />
        <div className={styles.text} />
        <OptionalImage src={store.prize1Img} alt="预约奖励" className={styles.prize1Img} />
        <div className={styles.subTitle} />
        <OptionalImage src={store.prize2Img} alt="部分奖励展示" className={styles.prize2Img} />
        <Link className={styles.btnDraw} />
      </div>
    </ModalContainer>
  );
};

export default wrapStore(OrderSuccessModal, OrderSuccessModalStore);
